export const numberOfProductsInCart = (cart) => {
    let total = 0;

    Object.values(cart).forEach((product) => {
        if (product.amount) {
            total += 1;
        }
    });

    return total;
};

export const totalPriceOfProductsInCart = (cart) => {
    let total = 0;

    Object.values(cart).forEach((item) => {
        total += item.price * item.amount;
    });

    return total.toFixed(2);
};



// WEBPACK FOOTER //
// ./resources/components/shop/helpers.js